export enum AvailableEmpresaFilters {
    Frecuencias = "frecuencias",
    TiposVisita = "tiposVisita",
    Estados = "estados",
    TiposEmpresa = "tiposEmpresa",
    Municipios = "municipios",
    Turnos = "turnos",
    Prospectadores = "prospectadores",
}

export enum Turnos {
    Matutino = 1,
    Vespertino = 2,
    Nocturno = 3,
}